import logolight from "../../assets/images/optimize_logo dark.png";
import logodark from "../../assets/images/logo-dark.png";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FiEdit2 } from "react-icons/fi";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Table,
  Spinner,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axios from "axios";
import ExpenseSummaryDashboard from "./ExpenseSummary";
import ExpenseHeader from "./ExpenseHeader";

const ExpenseDashboard = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedExpenses, setSelectedExpenses] = useState([]);
  const [totalSelectedAmount, setTotalSelectedAmount] = useState(0);
  const [expenseDetail, setExpenseDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
 const userRole = localStorage.getItem("role");
  const userName = localStorage.getItem("name");
  // 🔹 Filter states
  const [filters, setFilters] = useState({
    category: "",
    person: "",
    project: "",
    payment_status: "",
    start_date: "",
    end_date: "",
  });
 // 🔹 Fetch projects
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get("https://api.hanoch.in/expense/project_categories/");
        setProjects(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error("Error fetching projects:", error);
        
      }
    };
    fetchProjects();
  }, []);
  // 🔹 Fetch Users
  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        "https://api.hanoch.in/users/clients/?is_active=true"
      );
      setUsers(res.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  //fetch categories

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get("https://api.hanoch.in/expense/categories/");
        setCategories(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error("Error fetching categories:", error);
        
      }
    };
    fetchCategories();
  }, []);

  // 🔹 Fetch Expenses
  const fetchExpenses = async (filterParams = {}) => {
    setLoading(true);
    try {
      const params = new URLSearchParams(filterParams).toString();
      const res = await axios.get(`https://api.hanoch.in/expense/?${params}`);
      const expenseData = res?.results || res.data || [];
      setExpenses(expenseData);
    } catch (err) {
      console.error("Error fetching expenses:", err);
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    fetchUsers();
    fetchExpenses();
  }, []);

  // 🔹 Auto-apply Filters (debounced)
  useEffect(() => {
    const delay = setTimeout(() => {
      const activeFilters = {};
      for (const [key, value] of Object.entries(filters)) {
        if (value) activeFilters[key] = value;
      }
      fetchExpenses(activeFilters);
    }, 500);
    return () => clearTimeout(delay);
  }, [filters]);

  // 🔹 Filter change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 Reset Filters
  const resetFilters = () => {
    setFilters({
      category: "",
      person: "",
      project: "",
      payment_status: "",
      start_date: "",
      end_date: "",
    });
    fetchExpenses(); // refetch all data
  };

  // 🔹 Fetch Expense Detail
  const fetchExpenseDetail = async (id) => {
    setDetailLoading(true);
    try {
      const res = await axios.get(
        `https://api.hanoch.in/expense/company-expense-detail-view/${id}/`
      );
      setExpenseDetail(res.data);
      setModalOpen(true);
    } catch (err) {
      console.error("Error fetching expense detail:", err);
    } finally {
      setDetailLoading(false);
    }
  };

  // 🔹 Handle select / deselect expense
  const handleSelect = (id, amount) => {
    setSelectedExpenses((prev) => {
      if (prev.some((item) => item.id === id)) {
        return prev.filter((item) => item.id !== id);
      } else {
        return [...prev, { id, amount: parseFloat(amount) }];
      }
    });
  };

  // 🔹 Calculate total selected
  useEffect(() => {
    const total = selectedExpenses.reduce((sum, e) => sum + e.amount, 0);
    setTotalSelectedAmount(total);
  }, [selectedExpenses]);

  const handleAddExpense = () => navigate("/addExpense");
  const handleProceed = () => {
    if (selectedExpenses.length === 0) return;
    navigate("/uploadPaymentProof", { state: { selectedExpenses } });
  };

  const isFilterApplied = Object.values(filters).some((val) => val !== "");

  return (
    <Container fluid className="p-3">
      {/* Header */}
     <ExpenseHeader/>

      <ExpenseSummaryDashboard />

      {/* 🔹 Filter Section */}
      <Card className="p-3 shadow-sm mt-3">
        <Form>
          <Row className="align-items-end">
            <Col md={2}>
              <FormGroup>
                <Label for="person">Name</Label>
                <Input
                  type="select"
                  name="person"
                  value={filters.person}
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.name}>
                      {user.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <Label for="category">Category</Label>
                <Input
                  type="select"
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                  
                >
                 <option value="">All</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.name}>
                          {cat.name}
                        </option>
                      ))}
                      </Input>
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <Label for="project">Project</Label>
                <Input
                  type="select"
                  name="project"
                  value={filters.project}
                  onChange={handleFilterChange}
                 >
                   <option value="">All</option>
                      {projects.map((proj) => (
                        <option key={proj.id} value={proj.name}>
                          {proj.name}
                        </option>
                      ))}

                 </Input>
                
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <Label for="payment_status">Payment</Label>
                <Input
                  type="select"
                  name="payment_status"
                  value={filters.payment_status}
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  <option value="paid">Paid</option>
                  <option value="unpaid">Unpaid</option>
                </Input>
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <Label>Start Date</Label>
                <Input
                  type="date"
                  name="start_date"
                  value={filters.start_date}
                  onChange={handleFilterChange}
                />
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <Label>End Date</Label>
                <Input
                  type="date"
                  name="end_date"
                  value={filters.end_date}
                  onChange={handleFilterChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col className="d-flex justify-content-end">
              <Button color="secondary" onClick={resetFilters}>
                Reset
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>

      {/* Add Expense */}
      
<div className="d-flex flex-wrap gap-2 mb-3 justify-content-center">
  <Button color="primary" size="m" className="mt-3" onClick={handleAddExpense}>
        Add Expense
      </Button>
        <Button
          color="primary"
          size="m" className="mt-3"
          onClick={() => navigate("/addExpenseUser")}
        >
          User
        </Button>
        <Button
          color="primary"
          size="m" className="mt-3"
          onClick={() => navigate("/addExpenseCategory")}
        >
          Category
        </Button>
        <Button
          color="primary"
          size="m" className="mt-3"
          onClick={() => navigate("/addProject")}
        >
          Project
        </Button>
      </div>
      {/* Selected Total + Proceed */}
     {selectedExpenses.length > 0 && (
  <div className="my-3 text-center">
    <h5 className="fw-bold">
      Selected Total: ₹{totalSelectedAmount.toFixed(2)}
    </h5>

   {/* Show only if admin OR the logged-in user added the selected expenses */}
{selectedExpenses.length > 0 &&
  expenses.some(
    item =>
      selectedExpenses.some(sel => sel.id === item.id) &&
      (userName === "Hanoch Admin" || item.person_name === userName)
      
  ) && (
    <Button color="success" className="mt-2" onClick={handleProceed}>
      Proceed to Payment
    </Button>
  )}

  </div>
)}

      {/* 🔹 Expense Table */}
      <Row className="mt-3">
        <Col>
          <Card className="shadow-sm border-0">
            <CardBody>
              <CardTitle tag="h5">Expense List</CardTitle>

              {loading ? (
                <div className="text-center py-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <div className="table-responsive">
                  <Table hover bordered>
                    <thead className="table-light">
                      <tr>
                        <th>
                          {expenses.length > 0 && (
                            <input
                              type="checkbox"
                              checked={
                                selectedExpenses.length === expenses.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedExpenses(
                                    expenses.map((item) => ({
                                      id: item.id,
                                      amount: parseFloat(item.total_cost),
                                    }))
                                  );
                                } else {
                                  setSelectedExpenses([]);
                                }
                              }}
                            />
                          )}
                        </th>
                        <th>#</th>
                        <th>Date</th>
                        <th>Name</th>
                        <th>Project</th>
                        <th>Category</th>
                        <th>Remarks</th>
                        <th>Supplier</th>
                        <th>Amount (₹)</th>
                        <th>Payment Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                   <tbody>
  {expenses.map((item, index) => (
    <tr
      key={item.id}
      style={{ cursor: "pointer" }}
      onClick={() => fetchExpenseDetail(item.id)}
    >
      <td onClick={(e) => e.stopPropagation()}>
        <input
          type="checkbox"
          checked={selectedExpenses.some((exp) => exp.id === item.id)}
          onChange={() => handleSelect(item.id, item.total_cost)}
        />
      </td>
      <td>{index + 1}</td>
      <td>{item.date}</td>
      <td>{item.person_name}</td>
      <td>{item.project_name}</td>
      <td>{item.category_name}</td>
      <td>{item.remarks}</td>
      <td>{item.supplier}</td>
      <td>{item.total_cost}</td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill text-white fw-semibold ${
            item.payment_status?.toLowerCase() === "paid"
              ? "bg-success"
              : "bg-danger"
          }`}
          style={{ fontSize: "0.8rem" }}
        >
          {item.payment_status}
        </span>
      </td>
      <td onClick={(e) => e.stopPropagation()}>
        <Button
          color="link"
          className="p-0 border-0 shadow-none"
          onClick={() => fetchExpenseDetail(item.id)}
          title="View / Edit"
        >
          <FiEdit2 size={18} color="#0d6efd" />
        </Button>
      </td>
    </tr>
  ))}
</tbody>

                  </Table>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* 🔹 Expense Detail Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg" centered>
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          <strong>Expense Details</strong>
        </ModalHeader>

        <ModalBody>
          {detailLoading ? (
            <div className="text-center my-4">
              <Spinner color="primary" />
            </div>
          ) : expenseDetail ? (
            <div className="px-2">
              <Row className="mb-3">
                <Col md="6">
                  <strong>Date:</strong>
                  <p className="text-muted mb-0">{expenseDetail.date}</p>
                </Col>
                <Col md="6">
                  <strong>Person:</strong>
                  <p className="text-muted mb-0">{expenseDetail.person_name}</p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md="6">
                  <strong>Category:</strong>
                  <p className="text-muted mb-0">{expenseDetail.category_name}</p>
                </Col>
                <Col md="6">
                  <strong>Supplier:</strong>
                  <p className="text-muted mb-0">{expenseDetail.supplier}</p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md="6">
                  <strong>Total Cost:</strong>
                  <p className="text-success fw-bold mb-0">
                    ₹{expenseDetail.total_cost}
                  </p>
                </Col>
                <Col md="6">
                  <strong>Payment Status:</strong>
                  <p
                    className={`fw-semibold mb-0 ${expenseDetail.payment_status === "Paid"
                        ? "text-success"
                        : "text-danger"
                      }`}
                  >
                    {expenseDetail.payment_status}
                  </p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <strong>Remarks:</strong>
                  <p className="text-muted mb-0">
                    {expenseDetail.remarks || "—"}
                  </p>
                </Col>
              </Row>

             {(expenseDetail.bill_image || expenseDetail.payment_proof) && (
  <Row className="mt-3">
    {/* Bill Image / PDF */}
    {expenseDetail.bill_image && (
      <Col md="6" className="text-center mb-3">
        <strong>Bill File:</strong>
        <div className="mt-2">
          {expenseDetail.bill_image.toLowerCase().endsWith(".pdf") ? (
            <Button
              color="primary"
              size="sm"
              className="mt-2"
              onClick={() => window.open(expenseDetail.bill_image, "_blank")}
            >
              📄 View / Download PDF
            </Button>
          ) : (
            <img
              src={expenseDetail.bill_image}
              alt="Bill"
              className="img-fluid rounded shadow-sm"
              style={{ maxHeight: "250px", objectFit: "contain" }}
            />
          )}
        </div>
      </Col>
    )}

    {/* Payment Proof / PDF */}
    {expenseDetail.payment_proof && (
      <Col md="6" className="text-center mb-3">
        <strong>Payment Proof:</strong>
        <div className="mt-2">
          {expenseDetail.payment_proof.toLowerCase().endsWith(".pdf") ? (
            <Button
              color="primary"
              size="sm"
              className="mt-2"
              onClick={() => window.open(expenseDetail.payment_proof, "_blank")}
            >
              📄 View / Download PDF
            </Button>
          ) : (
            <img
              src={expenseDetail.payment_proof}
              alt="Payment Proof"
              className="img-fluid rounded shadow-sm"
              style={{ maxHeight: "250px", objectFit: "contain" }}
            />
          )}
        </div>
      </Col>
    )}
  </Row>
)}

            </div>
          ) : (
            <p className="text-center text-muted my-3">
              No details available.
            </p>
          )}
        </ModalBody>

       <ModalFooter>
  {expenseDetail && expenseDetail.payment_status?.toLowerCase() === "unpaid" && (
    <Button
      color="danger"
      onClick={async () => {
        const confirmDelete = window.confirm(
          "Are you sure you want to delete this unpaid expense?"
        );
        if (!confirmDelete) return;

        try {
          await axios.delete(
            `https://api.hanoch.in/expense/expenses/${expenseDetail.id}/`
          );
          alert("Expense deleted successfully!");
          setModalOpen(false);
          fetchExpenses(); // 🔹 Refresh the expense list
        } catch (error) {
          console.error("Error deleting expense:", error);
          alert("Failed to delete the expense. Please try again.");
        }
      }}
    >
      Delete
    </Button>
  )}

  <Button color="secondary" onClick={() => setModalOpen(false)}>
    Close
  </Button>
</ModalFooter>

      </Modal>
    </Container>
  );
};

export default ExpenseDashboard;
